import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { router } from "router/index";
import { store } from "store";
import { Provider } from "react-redux";
import locale from "antd/locale/zh_TW";
import dayjs from "dayjs";
import { ConfigProvider } from "antd";
import { Quill } from "react-quill";
import QuillResizeImage from "quill-resize-image";

import "dayjs/locale/zh-cn";

dayjs.locale("zh-TW");
Quill.register("modules/resize", QuillResizeImage);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={locale}>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
